import 'dayjs/locale/pt-br'
import { X } from 'react-feather'
import { useForm } from 'react-hook-form'
import { FilterActionButton } from '../FilterActionButton'
import { useDispatch } from 'react-redux'
import { useReceivement } from 'src/hooks/useReceivement'
import { actions } from '../../ReceivementOverviewListState'
import {
  CustomRow,
  FilterActions,
  FilterButton,
  FiltersForm,
  FlexCol,
} from './OverviewListFilters.style'
import { DateIntervalPicker } from '../DateIntervalPicker'
import { SupplierFilterSelect } from '../SupplierFilterSelect'
import { ArNumberFilterInput } from '../ArNumberFilterInput'
import { InvoiceNumberFilterInput } from '../InvoiceNumberFilterInput'
import { InvoiceKeyFilterInput } from '../InvoiceKeyFilterInput'
import { FcFilterSelect } from '../FcFilterSelect'
import { StatusFilterSelect } from '../StatusFilterSelect'
import { useStore } from 'src/utils/store'

export const OverviewListFilters = () => {
  const store = useStore()
  const dispatch = useDispatch()
  const { handleSubmit } = useForm()
  const { supervisorBadge } = useReceivement({ validateSupervisor: true })

  const filterReceivements = () => {
    const { startDate, endDate } = store.getState().receivementOverviewList
    if (startDate && endDate) {
      dispatch(actions.getReceivementOverviewList({ badge: supervisorBadge, page: 1 }))
    }
  }

  const clearForm = () => dispatch(actions.clearFilters())

  return (
    <FiltersForm onSubmit={handleSubmit(filterReceivements)}>
      <FilterActions>
        <FilterActionButton icon={<X />} label='Limpar filtros' onClick={clearForm} />
      </FilterActions>

      <CustomRow>
        <FlexCol sm='12' md='12' xl='4'>
          <DateIntervalPicker />
        </FlexCol>

        <FlexCol sm='12' md='6' xl='2'>
          <FcFilterSelect />
        </FlexCol>

        <FlexCol sm='12' md='6'>
          <SupplierFilterSelect />
        </FlexCol>
      </CustomRow>

      <CustomRow>
        <FlexCol sm='12' md='6' xl='2'>
          <ArNumberFilterInput />
        </FlexCol>

        <FlexCol sm='12' md='6' xl='2'>
          <StatusFilterSelect />
        </FlexCol>

        <FlexCol sm='12' md='6' xl='2'>
          <InvoiceNumberFilterInput />
        </FlexCol>

        <FlexCol sm='12' md='6'>
          <InvoiceKeyFilterInput />

          <FilterButton type='submit' variant='contained' size='small'>
            Buscar
          </FilterButton>
        </FlexCol>
      </CustomRow>
    </FiltersForm>
  )
}
